import React, { useState, useEffect } from 'react';
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap';
import Widgets1 from '../../../Common/CommonWidgets/Widgets1';
import SocialWidget from '../../../Common/CommonWidgets/SocialWidget';
import axios from 'axios';
import config from '../../../../config';
import visitors from '../../../../assets/images/logo/visitors.png';
import male from '../../../../assets/images/logo/male.png';
import female from '../../../../assets/images/logo/female.png';
import child from '../../../../assets/images/logo/child.png';



const WidgetWrapper = ({ propertyId, startDate, endDate, floor, zone, entrance, device }) => {
  const token = localStorage.getItem('sessiontoken');
  const configheader = {
    headers: {
      Authorization: `${token}`
    }
  };

  const concessionaire_id = localStorage.getItem('concessionaireId');  
  const property_access = localStorage.getItem("propertyAccess");

  const [data, setData] = useState({
    traffic: '',
    sales: '',
    conversion: '',
    atv: '',
    shopperYield: '',
    demographics: {}
  });

  const [hasDemographics, setHasDemographics] = useState(false);

  useEffect(() => {
    setData({
      traffic: '',
      sales: '',
      conversion: '',
      atv: '',
      shopperYield: '',
      demographics: {}
    });

    axios
      .post(
        `${config.hostname}/trafficdashboard/getdetails`,
        {
          concessionaire_id,
          property_id: propertyId,
          start_date: startDate,
          end_date: endDate,
          property_access:property_access,
          ...(floor && { floor }),
          ...(zone && { zone }),
          ...(entrance && { entrance_name: entrance }),
          ...(device && { device_name: device }),
        },
        configheader
      )
      .then(response => {
        const res = response.data;
        setData({
          traffic: Number(res.totalTraffic).toLocaleString(),
          sales: Number(res.totalNetSales).toLocaleString(),
          conversion: Number(res.conversion).toLocaleString(),
          atv: Number(res.atv).toLocaleString(),
          shopperYield: Number(res.shopperYield).toLocaleString(),
          demographics: res.demographics || {}
        });
      })
      .catch(() => {
        setData({
          traffic: '',
          sales: '',
          conversion: '',
          atv: '',
          shopperYield: '',
          demographics: {}
        });
      });
  }, [propertyId, startDate, endDate, floor, zone, entrance, device]);

  useEffect(() => {
    setHasDemographics(Object.keys(data.demographics).length > 0);
  }, [data.demographics]);

  // KPI widgets
  const coreWidgets = [
    { title: 'Traffic', total: data.traffic, color: 'primary', icon: 'customers' },
    { title: 'Sales', total: data.sales, color: 'secondary', icon: 'profit' },
    { title: 'Conversion', total: `${data.conversion}%`, color: 'success', icon: 'sale' },
    { title: 'ATV', total: data.atv, color: 'warning', icon: 'course-1' },
    { title: 'Shopper Yield', total: data.shopperYield, color: 'primary', icon: 'course-2' }
  ];

  // Demographic widgets
  const demographicWidgets = Array.isArray(data.demographics)
    ? data.demographics.map((item) => {
        let categoryImage = visitors; 
        const title = item.category?.toLowerCase();

        if (title.includes('female')) categoryImage = female;      
        else if (title.includes('male')) categoryImage = male;
        else if (title.includes('child')) categoryImage = child;
        else categoryImage = visitors;

        return {
          title: item.category,
          image: categoryImage,
          total: Number(item.count).toLocaleString(),
          subTitle: `${item.percentage}% of Visitors`,
          status: 'success',
          chart: {
            color: ['#46a2dbff'], // blue accent
            series: [item.percentage],
          },
        };
      })
    : [];
  return (
    <Row>
      {/* KPIs Card */}
      <Card className="mb-3">
        <CardBody>
          <Row>
            {coreWidgets.map((widget, idx) => (
              <Col key={idx}>
                <Widgets1 data={widget} />
              </Col>
            ))}
          </Row>
        </CardBody>
      </Card>

      {/* Demographics Card */}
      {hasDemographics && (
        <Card>
          <CardBody>            
            <h5 className="mb-0">Demographics</h5>
            <Row>
              {demographicWidgets.map((item, i) => (
          <Col xl="3" sm="6" key={i}>
            <SocialWidget data={item} />
          </Col>
        ))}
            </Row>
          </CardBody>
        </Card>
      )}
    </Row>
  );
};

export default WidgetWrapper;
